/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import {
  AddToList,
  Country,
  Coupon,
  CouponsFilter,
  LoyaltyCard,
  MemberCategory,
  MemberInfo,
  Paginator,
  PointSource,
  TicketCategory,
} from '../models/member-summary.models';
import { Schema, TicketStatus } from '../models/members-search.models';

export const ViewMember = createAction(
  '[Loyalty Members: Summary]: View Member',
  props<{ member: any }>(),
);

export const ViewMemberById = createAction(
  '[Loyalty Members: Summary]: View Member By Id',
  props<{ loyaltyMemberId: number }>(),
);

export const ViewMemberSearchPage = createAction(
  '[Loyalty Members: Summary]: View Member Search Page',
);

export const LoadLMSummaryData = createAction('[Loyalty Members: Summary]: Load LM Summary Data');

export const LoadMemberDetailsData = createAction(
  '[Loyalty Members: Details]: Load Member Details Data',
);

export const GetLoyaltyMemberDataSuccess = createAction(
  '[Loyalty Members: Summary]: Get Loyalty Member Data Success',
  props<{ res: MemberInfo }>(),
);

export const GetLoyaltyMemberDataFailed = createAction(
  '[Loyalty Members: Summary]: Get Loyalty Member Data Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetDetailedRFMAnalysisSuccess = createAction(
  '[Loyalty Members: Summary]: Get Detailed RFM Analysis Success',
  props<{ res: any }>(),
);

export const GetDetailedRFMAnalysisFailed = createAction(
  '[Loyalty Members: Summary]: Get Detailed RFM Analysis Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCouponsetSuccess = createAction(
  '[Loyalty Members: Summary]: Get Couponset Success',
  props<{ res: any }>(),
);

export const GetCouponsetFailed = createAction(
  '[Loyalty Members: Summary]: Get Couponset Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCountriesSuccess = createAction(
  '[Loyalty Members: Summary]: Get Countries Success',
  props<{ res: Country[] }>(),
);

export const GetCountriesFailed = createAction(
  '[Loyalty Members: Summary]: Get Countries Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetSeveritiesSuccess = createAction(
  '[Loyalty Members: Summary]: Get Severities Success',
  props<{ res: any }>(),
);

export const GetSeveritiesFailed = createAction(
  '[Loyalty Members: Summary]: Get Severities Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetMemberStatusesSuccess = createAction(
  '[Loyalty Members: Summary]: Get Member Statuses Success',
  props<{ res: any }>(),
);

export const GetMemberStatusesFailed = createAction(
  '[Loyalty Members: Summary]: Get Member Statuses Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetTicketStatusesSuccess = createAction(
  '[Loyalty Members: Summary]: Get Ticket Statuses Success',
  props<{ res: TicketStatus[] }>(),
);

export const GetTicketStatusesFailed = createAction(
  '[Loyalty Members: Summary]: Get Ticket Statuses Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetAssignmentsSuccess = createAction(
  '[Loyalty Members: Summary]: Get Assignments Success',
  props<{ res: any }>(),
);

export const GetAssignmentsFailed = createAction(
  '[Loyalty Members: Summary]: Get Assignments Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCommunicationChannelsSuccess = createAction(
  '[Loyalty Members: Summary]: Get Communication Channels Success',
  props<{ res: any }>(),
);

export const GetCommunicationChannelsFailed = createAction(
  '[Loyalty Members: Summary]: Get Communication Channels Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetAvailableLanguagesSuccess = createAction(
  '[Loyalty Members: Summary]: Get Available Languages Success',
  props<{ res: any }>(),
);

export const GetAvailableLanguagesFailed = createAction(
  '[Loyalty Members: Summary]: Get Available Languages Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCustomerSuccess = createAction(
  '[Loyalty Members: Summary]: Get Customer Success',
  props<{ res: any }>(),
);

export const GetCustomerFailed = createAction(
  '[Loyalty Members: Summary]: Get Customer Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCategoriesSuccess = createAction(
  '[Loyalty Members: Summary]: Get Categories Success',
  props<{ res: MemberCategory[] }>(),
);

export const GetCategoriesFailed = createAction(
  '[Loyalty Members: Summary]: Get Categories Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetTicketCategoriesSuccess = createAction(
  '[Loyalty Members: Summary]: Get Ticket Categories Success',
  props<{ res: TicketCategory[] }>(),
);

export const GetTicketCategoriesFailed = createAction(
  '[Loyalty Members: Summary]: Get Ticket Categories Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const FindCampaignsSuccess = createAction(
  '[Loyalty Members: Summary]: Find CampaignsS Success',
  props<{ res: AddToList[] }>(),
);

export const FindCampaignsSFailed = createAction(
  '[Loyalty Members: Summary]: Find CampaignsS Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCSIChartsSuccess = createAction(
  '[Loyalty Members: Summary]: Get CSI Charts Success',
  props<{ res: any }>(),
);

export const GetCSIChartsFailed = createAction(
  '[Loyalty Members: Summary]: Get CSI Charts Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetLifecycleChartsSuccess = createAction(
  '[Loyalty Members: Summary]: Get Lifecycle Charts Success',
  props<{ res: any }>(),
);

export const GetLifecycleChartsFailed = createAction(
  '[Loyalty Members: Summary]: Get Lifecycle Charts Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetMemberSourcesSuccess = createAction(
  '[Loyalty Members: Summary]: Get Member Sources Success',
  props<{ res: any }>(),
);

export const GetMemberSourcesFailed = createAction(
  '[Loyalty Members: Summary]: Get Member Sources Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetMemberSchemasSuccess = createAction(
  '[Loyalty Members: Summary]: Get Member Schemas Success',
  props<{ res: Schema[] }>(),
);

export const GetMemberSchemasFailed = createAction(
  '[Loyalty Members: Summary]: Get Member Schemas Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetMemberStoresSuccess = createAction(
  '[Loyalty Members: Summary]: Get Member Stores Success',
  props<{ res: any }>(),
);

export const GetMemberStoresFailed = createAction(
  '[Loyalty Members: Summary]: Get Member Stores Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetLoyaltyCardSuccess = createAction(
  '[Loyalty Members: Summary]: Get Loyalty Card Success',
  props<{ res: any }>(),
);

export const GetLoyaltyCardFailed = createAction(
  '[Loyalty Members: Summary]: Get Loyalty Card Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCustomerReportingSuccess = createAction(
  '[Loyalty Members: Summary]: Get Customer Reporting Success',
  props<{ res: any }>(),
);

export const GetCustomerReportingFailed = createAction(
  '[Loyalty Members: Summary]: Get Customer Reporting Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetMemberScannedFormSuccess = createAction(
  '[Loyalty Members: Summary]: Get Member Scanned Form Success',
  props<{ res: any }>(),
);

export const GetMemberScannedFormFailed = createAction(
  '[Loyalty Members: Summary]: Get Member Scanned Form Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetMemberPointSourcesSuccess = createAction(
  '[Loyalty Members: Summary]: Get Member Point Sources Success',
  props<{ res: PointSource[] }>(),
);

export const GetMemberPointSourcesFailed = createAction(
  '[Loyalty Members: Summary]: Get Member Point Sources Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenReservedPointsModal = createAction(
  '[Loyalty Members: Summary]: Open Reserved Points Modal',
);

export const GetActiveReservedPointsSuccess = createAction(
  '[Loyalty Members: Summary]: Get Active Reserved Points Success',
  props<{ res: PointSource[] }>(),
);

export const GetActiveReservedPointsFailed = createAction(
  '[Loyalty Members: Summary]: Get Active Reserved Points Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetInactiveReservedPointsSuccess = createAction(
  '[Loyalty Members: Summary]: Get Inactive Reserved Points Success',
  props<{ res: PointSource[] }>(),
);

export const GetInactiveReservedPointsFailed = createAction(
  '[Loyalty Members: Summary]: Get Inactive Reserved Points Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenDeactivateLM = createAction(
  '[Loyalty Members: Summary]: Open Deactivate Loyalty Member',
);

export const DeactivateLM = createAction('[Loyalty Members: Summary]: Deactivate Loyalty Member');

export const DeactivateLMSuccess = createAction(
  '[Loyalty Members: Summary]: Deactivate Loyalty Member Success',
  props<{ res: any }>(),
);

export const DeactivateLMFailed = createAction(
  '[Loyalty Members: Summary]: Deactivate Loyalty Member Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenAnonymizeLM = createAction(
  '[Loyalty Members: Summary]: Open Anonymize Loyalty Member',
);

export const AnonymizeLM = createAction('[Loyalty Members: Summary]: Anonymize Loyalty Member');

export const AnonymizeLMSuccess = createAction(
  '[Loyalty Members: Summary]: Anonymize Loyalty Member Success',
  props<{ res: any }>(),
);

export const AnonymizeLMFailed = createAction(
  '[Loyalty Members: Summary]: Anonymize Loyalty Member Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenAddToListLM = createAction(
  '[Loyalty Members: Summary]: Open Add to list Loyalty Member',
);

export const AddToListLM = createAction('[Loyalty Members: Summary]: Add to list Loyalty Member');

export const AddToListLMSuccess = createAction(
  '[Loyalty Members: Summary]: Add to list Loyalty Member Success',
  props<{ res: any }>(),
);

export const AddToListLMFailed = createAction(
  '[Loyalty Members: Summary]: Add to list Loyalty Member Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenAdhocpointsLM = createAction(
  '[Loyalty Members: Summary]: Open Adhoc points Loyalty Member',
);

export const AdhocpointsLM = createAction(
  '[Loyalty Members: Summary]: Adhoc points Loyalty Member',
);

export const AdhocpointsLMSuccess = createAction(
  '[Loyalty Members: Summary]: Adhoc points Loyalty Member Success',
  props<{ res: any }>(),
);

export const AdhocpointsLMFailed = createAction(
  '[Loyalty Members: Summary]: Adhoc points Loyalty Member Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenConsentLM = createAction(
  '[Loyalty Members: Summary]: Open Consent Loyalty Member',
);

export const OpenCreateTicketLM = createAction(
  '[Loyalty Members: Summary]: Open Create Ticket Loyalty Member',
);

export const TicketCategoryChanged = createAction(
  '[Loyalty Members: Summary]: Ticket Category Changed',
  props<{ category: string }>(),
);

export const TicketSubjectChanged = createAction(
  '[Loyalty Members: Summary]: Ticket Subject Changed',
  props<{ subject: string }>(),
);

export const TicketCountryChanged = createAction(
  '[Loyalty Members: Summary]: Ticket Country Changed',
  props<{ country: string }>(),
);

export const TicketBodyChanged = createAction(
  '[Loyalty Members: Summary]: Ticket Body Changed',
  props<{ body: string }>(),
);

export const CreateTicketLM = createAction(
  '[Loyalty Members: Summary]: Create Ticket Loyalty Member',
);

export const CreateTicketLMSuccess = createAction(
  '[Loyalty Members: Summary]: Create Ticket Loyalty Member Success',
  props<{ res: any }>(),
);

export const CreateTicketLMFailed = createAction(
  '[Loyalty Members: Summary]: Create Ticket Loyalty Member Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CloseCreateNewTicket = createAction(
  '[Loyalty Members: Summary]: Close Create New Ticket',
);

export const AddToListFilterChanged = createAction(
  '[Loyalty Members: Summary]: Add To List Filter Changed',
  props<{ addToListFilter: string }>(),
);

export const AddToListChanged = createAction(
  '[Loyalty Members: Summary]: Add To List Changed',
  props<{ addToList: string }>(),
);

export const CloseAddToListModal = createAction(
  '[Loyalty Members: Summary]: Close AddToList Modal',
);

export const PointsChanged = createAction(
  '[Loyalty Members: Summary]: Points Changed',
  props<{ points: string }>(),
);

export const RemarksChanged = createAction(
  '[Loyalty Members: Summary]: Remarks Changed',
  props<{ remarks: string }>(),
);

export const PointSourceChanged = createAction(
  '[Loyalty Members: Summary]: Point Source Changed',
  props<{ pointSource: number }>(),
);

export const CloseAdhocPoints = createAction('[Loyalty Members: Summary]: Close Adhoc Points');

export const InitConsentColumns = createAction(
  '[Loyalty Members: Summary]: Init Consent Columns',
  props<{ displayedColumns: { [key: string]: string } }>(),
);

export const RedeemAdHocPoints = createAction('[Loyalty Members: Summary]: Redeem AdHoc Points');

export const RedeemAdHocPointsSuccess = createAction(
  '[Loyalty Members: Summary]: Redeem AdHoc Points Success',
  props<{ res: any }>(),
);

export const RedeemAdHocPointsFailed = createAction(
  '[Loyalty Members: Summary]: Redeem AdHoc Points Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const LMAddToList = createAction('[Loyalty Members: Summary]: LM Add To List');

export const LMAddToListSuccess = createAction(
  '[Loyalty Members: Summary]: LM Add To List Success',
  props<{ res: any }>(),
);

export const LMAddToListFailed = createAction(
  '[Loyalty Members: Summary]: LM Add To List Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const DeactivateMember = createAction('[Loyalty Members: Summary]: Deactivate Member');

export const DeactivateMemberSuccess = createAction(
  '[Loyalty Members: Summary]: Deactivate Member Success',
  props<{ res: any }>(),
);

export const DeactivateMemberFailed = createAction(
  '[Loyalty Members: Summary]: Deactivate Member Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const InitActivateMemberColumns = createAction(
  '[Loyalty Members: Summary]: Init Activate Member Columns',
  props<{ displayedColumns: { [key: string]: string } }>(),
);

export const InitPointReservationsColumns = createAction(
  '[Loyalty Members: Summary]: Init Point Reservations Columns',
  props<{ pointReservationsColumns: { [key: string]: string } }>(),
);

export const ShowProcessedChanged = createAction(
  '[Loyalty Members: Summary]: Show Processed Changed',
);

export const OpenActivateCustomerLM = createAction(
  '[Loyalty Members: Summary]: Open Activate Customer Loyalty Member',
);

export const GetLoyaltyCardsSuccess = createAction(
  '[Loyalty Members: Summary]: Get Loyalty Cards Success',
  props<{ res: LoyaltyCard[] }>(),
);

export const GetLoyaltyCardsFailed = createAction(
  '[Loyalty Members: Summary]: Get Loyalty Cards Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const CloseActivateCustomerModal = createAction(
  '[Loyalty Members: Summary]: Close Activate Customer Modal',
);

export const ActivateCustomerLM = createAction(
  '[Loyalty Members: Summary]: Activate Customer Loyalty Member',
  props<{ cardNumber: string }>(),
);

export const ActivateCustomerLMSuccess = createAction(
  '[Loyalty Members: Summary]: Activate Customer Loyalty Member Success',
);

export const LoyaltyCardStatusChanged = createAction(
  '[Loyalty Members: Summary]: Loyalty Card Status Changed',
  props<{ card: LoyaltyCard }>(),
);

export const ClosePanel = createAction('[Loyalty Members: Summary]: Close Panel');

export const OpenCardsPanel = createAction(
  '[Loyalty Members: Summary]: Open Cards Panel',
  props<{ displayedColumns: { [column: string]: string } }>(),
);

export const GetLoyaltyCardsTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Loyalty Cards Table Success',
  props<{ res: LoyaltyCard[] }>(),
);

export const GetLoyaltyCardsTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Loyalty Cards Table Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const MemberCardsAssignModal = createAction(
  '[Loyalty Members: Summary]: Member Cards Assign Modal',
);

export const CardNumberChanged = createAction(
  '[Loyalty Members: Summary]: Card Number Changed',
  props<{ cardNumber: string }>(),
);

export const PACardbatchChanged = createAction(
  '[Loyalty Members: Summary]: PA Card batch Changed',
  props<{ paCardbatch: string }>(),
);

export const CardBatchSelected = createAction(
  '[Loyalty Members: Summary]: Card Batch Selected',
  props<{ selectedCardBatch: any }>(),
);

export const GetCardBatchesSuccess = createAction(
  '[Loyalty Members: Summary]: Get Card Batches Success',
  props<{ cardBatches: any[] }>(),
);

export const GetCardBatchesFailed = createAction(
  '[Loyalty Members: Summary]: Get Card Batches Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CardTypeChanged = createAction('[Loyalty Members: Summary]: Card Type Changed');

export const CloseAssignCardModal = createAction(
  '[Loyalty Members: Summary]: Close Assign Card Modal',
);

export const AssignCard = createAction('[Loyalty Members: Summary]: Assign Card');

export const AssignCardSuccess = createAction(
  '[Loyalty Members: Summary]: Assign Card Success',
  props<{ res: any; memberName?: string; cardDetails?: string }>(),
);

export const AssignCardFailed = createAction(
  '[Loyalty Members: Summary]: Assign Card Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const AssignTemporaryCard = createAction(
  '[Loyalty Members: Summary]: Assign Temporary Card',
);

export const ObservationsChanged = createAction(
  '[Loyalty Members: Summary]: Observations Changed',
  props<{ observations: string }>(),
);

export const OpenCardLostDestroyModal = createAction(
  '[Loyalty Members: Summary]: Open Card LostDestroy Modal',
  props<{ loyaltyCardId: number }>(),
);

export const CloseCardLostDestroyModal = createAction(
  '[Loyalty Members: Summary]: Close Card LostDestroy Modal',
);

export const DestroyCard = createAction('[Loyalty Members: Summary]: Destroy Card');

export const DestroyCardSuccess = createAction(
  '[Loyalty Members: Summary]: Destroy Card Success',
  props<{ res: any }>(),
);

export const DestroyCardFailed = createAction(
  '[Loyalty Members: Summary]: Destroy Card Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenCampaignsPanel = createAction(
  '[Loyalty Members: Summary]: Open Campaigns Panel',
  props<{ displayedColumns: { [column: string]: string } }>(),
);

export const GetCampaignsTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Campaigns Table Success',
  props<{ res: LoyaltyCard[] }>(),
);

export const GetCampaignsTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Campaigns Table Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const GetCampaignsCountTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Campaigns Count Table Success',
  props<{ res: number }>(),
);

export const GetCampaignsCountTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Campaigns Count Table Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const OrderingInit = createAction(
  '[Loyalty Members: Summary]: Order Init',
  props<{ orderFieldOptions: string[]; selectedOrder: string }>(),
);

export const SortingInit = createAction(
  '[Loyalty Members: Summary]: Sorting Init',
  props<{ sortFieldOptions: string[]; selectedSortField: string }>(),
);

export const ItemsPerPageChanged = createAction(
  '[Loyalty Members: Summary]: Items Per Page Changed',
  props<{ itemsNumber: number }>(),
);

export const OrderingChanged = createAction(
  '[Loyalty Members: Summary]: Order Changed',
  props<{ selectedOrder: string }>(),
);

export const SortingChanged = createAction(
  '[Loyalty Members: Summary]: Sorting Changed',
  props<{ selectedSortField: string }>(),
);

export const PagingChanged = createAction(
  '[Loyalty Members: Summary]: Paging Changed',
  props<{ paginator: Paginator }>(),
);

// Campaigns-specific pagination actions
export const CampaignsItemsPerPageChanged = createAction(
  '[Loyalty Members: Campaigns]: Items Per Page Changed',
  props<{ itemsNumber: number }>(),
);

export const CampaignsOrderingChanged = createAction(
  '[Loyalty Members: Campaigns]: Order Changed',
  props<{ selectedOrder: string }>(),
);

export const CampaignsSortingChanged = createAction(
  '[Loyalty Members: Campaigns]: Sorting Changed',
  props<{ selectedSortField: string }>(),
);

export const CampaignsPagingChanged = createAction(
  '[Loyalty Members: Campaigns]: Paging Changed',
  props<{ paginator: Paginator }>(),
);

// Point Log-specific pagination actions
export const PointLogItemsPerPageChanged = createAction(
  '[Loyalty Members: PointLog]: Items Per Page Changed',
  props<{ itemsNumber: number }>(),
);
export const PointLogOrderingChanged = createAction(
  '[Loyalty Members: PointLog]: Order Changed',
  props<{ selectedOrder: string }>(),
);
export const PointLogSortingChanged = createAction(
  '[Loyalty Members: PointLog]: Sorting Changed',
  props<{ selectedSortField: string }>(),
);
export const PointLogPagingChanged = createAction(
  '[Loyalty Members: PointLog]: Paging Changed',
  props<{ paginator: Paginator }>(),
);

// Transactions-specific pagination actions
export const TransactionsItemsPerPageChanged = createAction(
  '[Loyalty Members: Transactions]: Items Per Page Changed',
  props<{ itemsNumber: number }>(),
);
export const TransactionsOrderingChanged = createAction(
  '[Loyalty Members: Transactions]: Order Changed',
  props<{ selectedOrder: string }>(),
);
export const TransactionsSortingChanged = createAction(
  '[Loyalty Members: Transactions]: Sorting Changed',
  props<{ selectedSortField: string }>(),
);
export const TransactionsPagingChanged = createAction(
  '[Loyalty Members: Transactions]: Paging Changed',
  props<{ paginator: Paginator }>(),
);

// Clubs-specific pagination actions
export const ClubsItemsPerPageChanged = createAction(
  '[Loyalty Members: Clubs]: Items Per Page Changed',
  props<{ itemsNumber: number }>(),
);
export const ClubsOrderingChanged = createAction(
  '[Loyalty Members: Clubs]: Order Changed',
  props<{ selectedOrder: string }>(),
);
export const ClubsSortingChanged = createAction(
  '[Loyalty Members: Clubs]: Sorting Changed',
  props<{ selectedSortField: string }>(),
);
export const ClubsPagingChanged = createAction(
  '[Loyalty Members: Clubs]: Paging Changed',
  props<{ paginator: Paginator }>(),
);

// Coupons-specific pagination actions
export const CouponsItemsPerPageChanged = createAction(
  '[Loyalty Members: Coupons]: Items Per Page Changed',
  props<{ itemsNumber: number }>(),
);
export const CouponsOrderingChanged = createAction(
  '[Loyalty Members: Coupons]: Order Changed',
  props<{ selectedOrder: string }>(),
);
export const CouponsSortingChanged = createAction(
  '[Loyalty Members: Coupons]: Sorting Changed',
  props<{ selectedSortField: string }>(),
);
export const CouponsPagingChanged = createAction(
  '[Loyalty Members: Coupons]: Paging Changed',
  props<{ paginator: Paginator }>(),
);

// Tickets-specific pagination actions
export const TicketsItemsPerPageChanged = createAction(
  '[Loyalty Members: Tickets]: Items Per Page Changed',
  props<{ itemsNumber: number }>(),
);
export const TicketsOrderingChanged = createAction(
  '[Loyalty Members: Tickets]: Order Changed',
  props<{ selectedOrder: string }>(),
);
export const TicketsSortingChanged = createAction(
  '[Loyalty Members: Tickets]: Sorting Changed',
  props<{ selectedSortField: string }>(),
);
export const TicketsPagingChanged = createAction(
  '[Loyalty Members: Tickets]: Paging Changed',
  props<{ paginator: Paginator }>(),
);

export const OpenCheckbooksPanel = createAction(
  '[Loyalty Members: Summary]: Open Checkbooks Panel',
  props<{ displayedColumns: { [column: string]: string } }>(),
);

export const GetCheckbooksTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Checkbooks Table Success',
  props<{ res: any[] }>(),
);

export const GetCheckbooksTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Checkbooks Table Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const GetCheckbooksCountTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Checkbooks Count Table Success',
  props<{ res: number }>(),
);

export const GetCheckbooksCountTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Checkbooks Count Table Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const CheckbookDetailsModal = createAction(
  '[Loyalty Members: Summary]: Checkbook Details Modal',
  props<{ checkbook: any }>(),
);

export const RemindCouponCode = createAction('[Loyalty Members: Summary]: Remind Coupon Code');

export const RemindCouponCodeSuccess = createAction(
  '[Loyalty Members: Summary]: Remind Coupon Code Success',
  props<{ res: number }>(),
);

export const RemindCouponCodeFailed = createAction(
  '[Loyalty Members: Summary]: Remind Coupon Code Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const UnassignCheckbookModal = createAction(
  '[Loyalty Members: Summary]: Unassign Checkbook Modal',
);

export const UnassignCheckbook = createAction('[Loyalty Members: Summary]: Unassign Checkbook');

export const UnassignCheckbookSuccess = createAction(
  '[Loyalty Members: Summary]: Unassign Checkbook Success',
  props<{ res: number }>(),
);

export const UnassignCheckbookFailed = createAction(
  '[Loyalty Members: Summary]: Unassign Checkbook Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const CheckbooksDisplayedColumnsInit = createAction(
  '[Loyalty Members: Summary]: Checkbooks Displayed Columns Init',
  props<{ checkbooksDisplayedColumns: { [key: string]: string } }>(),
);

export const CheckbooksItemsPerPageChanged = createAction(
  '[Loyalty Members: Checkbooks]: Items Per Page Changed',
  props<{ itemsNumber: number }>(),
);
export const CheckbooksOrderingChanged = createAction(
  '[Loyalty Members: Checkbooks]: Order Changed',
  props<{ selectedOrder: string }>(),
);
export const CheckbooksSortingChanged = createAction(
  '[Loyalty Members: Checkbooks]: Sorting Changed',
  props<{ selectedSortField: string }>(),
);
export const CheckbooksPagingChanged = createAction(
  '[Loyalty Members: Checkbooks]: Paging Changed',
  props<{ paginator: Paginator }>(),
);

export const SetSelectedCheckbook = createAction(
  '[Loyalty Members: Summary]: Set Selected Checkbook',
  props<{ bookCouponGroupId: number }>(),
);

export const OpenPointLogPanel = createAction(
  '[Loyalty Members: Summary]: Open Point Log Panel',
  props<{ displayedColumns: { [column: string]: string } }>(),
);

export const GetPointLogTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Point Log Table Success',
  props<{ res: any[] }>(),
);

export const GetPointLogTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Point Log Table Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const GetPointLogCountTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Point Log Count Table Success',
  props<{ res: number }>(),
);

export const GetPointLogCountTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Point Log Count Table Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const PointLogDisplayedColumnsInit = createAction(
  '[Loyalty Members: Summary]: Point Log Displayed Columns Init',
  props<{ pointLogDisplayedColumns: { [key: string]: string } }>(),
);

export const OpenClubsPanel = createAction(
  '[Loyalty Members: Summary]: Open Clubs Panel',
  props<{ displayedColumns: { [column: string]: string } }>(),
);

export const GetClubsTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Clubs Table Success',
  props<{ res: any[] }>(),
);

export const GetClubsTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Clubs Table Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetClubsCountTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Clubs Count Table Success',
  props<{ res: number }>(),
);

export const GetClubsCountTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Clubs Count Table Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ClubsDisplayedColumnsInit = createAction(
  '[Loyalty Members: Summary]: Clubs Displayed Columns Init',
  props<{ clubsDisplayedColumns: { [key: string]: string } }>(),
);

export const ToggleClubActivation = createAction(
  '[Loyalty Members: Summary]: Toggle Club Activation',
  props<{ loyaltyMemberClubId: number; activate: boolean }>(),
);

export const ToggleClubActivationSuccess = createAction(
  '[Loyalty Members: Summary]: Toggle Club Activation Success',
  props<{ loyaltyMemberClubId: number }>(),
);

export const ToggleClubActivationFailed = createAction(
  '[Loyalty Members: Summary]: Toggle Club Activation Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenAssignClubModal = createAction(
  '[Loyalty Members: Summary]: Open Assign Club Modal',
);

export const GetActiveClubsSuccess = createAction(
  '[Loyalty Members: Summary]: Get Active Clubs Success',
  props<{ res: any[] }>(),
);

export const GetActiveClubsFailed = createAction(
  '[Loyalty Members: Summary]: Get Active Clubs Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const AssignClubToMember = createAction(
  '[Loyalty Members: Summary]: Assign Club To Member',
  props<{ clubData: { clubCode: string; startDate: any; endDate: any } }>(),
);

export const AssignClubToMemberSuccess = createAction(
  '[Loyalty Members: Summary]: Assign Club To Member Success',
);

export const AssignClubToMemberFailed = createAction(
  '[Loyalty Members: Summary]: Assign Club To Member Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CloseAssignClubModal = createAction(
  '[Loyalty Members: Summary]: Close Assign Club Modal',
);

export const AssignClubCodeChanged = createAction(
  '[Loyalty Members: Summary]: Assign Club Code Changed',
  props<{ clubCode: string }>(),
);

export const AssignClubStartDateChanged = createAction(
  '[Loyalty Members: Summary]: Assign Club Start Date Changed',
  props<{ startDate: Date | null }>(),
);

export const AssignClubEndDateChanged = createAction(
  '[Loyalty Members: Summary]: Assign Club End Date Changed',
  props<{ endDate: Date | null }>(),
);

export const OpenTicketsPanel = createAction(
  '[Loyalty Members: Summary]: Open Tickets Panel',
  props<{ displayedColumns: { [column: string]: string } }>(),
);

export const GetTicketsTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Tickets Table Success',
  props<{ res: any[] }>(),
);

export const GetTicketsTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Tickets Table Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const GetTicketsCountTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Tickets Count Table Success',
  props<{ res: number }>(),
);

export const GetTicketsCountTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Tickets Count Table Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const MemberCreateTicketModal = createAction(
  '[Loyalty Members: Summary]: Member Create Ticket Modal',
);

export const MemberEditTicketModal = createAction(
  '[Loyalty Members: Summary]: Member Edit Ticket Modal',
  props<{ editTicket: any }>(),
);

export const MemberCloseEditTicketModal = createAction(
  '[Loyalty Members: Summary]: Member Close Edit Ticket Modal',
);

export const TicketAssigneeChanged = createAction(
  '[Customer data: Edit Ticket]: Ticket Assignee Changed',
  props<{ ticketAssignee: number }>(),
);

export const TicketSeverityChanged = createAction(
  '[Customer data: Edit Ticket]: Ticket Severity Changed',
  props<{ ticketSeverity: number }>(),
);

export const TicketStatusChanged = createAction(
  '[Customer data: Edit Ticket]: Ticket Status Changed',
  props<{ ticketStatus: number }>(),
);

export const MemberTicketSearchFieldChanged = createAction(
  '[Customer data: Edit Ticket]: Search Field Changed',
  props<{ searchField: string }>(),
);

export const MemberTicketMatchMember = createAction('[Customer data: Edit Ticket]: Match Member');

export const MemberTicketMatchMemberSuccess = createAction(
  '[Customer data: Edit Ticket]: Match Member Success',
  props<{ res: any[] }>(),
);

export const MemberTicketMatchMemberFailed = createAction(
  '[Customer data: Edit Ticket]: Match Member Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const MemberTicketRemoveMember = createAction('[Customer data: Edit Ticket]: Remove Member');

export const CreateMemberTicket = createAction(
  '[Customer data: Edit Ticket]: Create Member Ticket',
);

export const CreateMemberTicketSuccess = createAction(
  '[Customer data: Edit Ticket]: Create Member Ticket Success',
  props<{ res: any }>(),
);

export const CreateMemberTicketFailed = createAction(
  '[Customer data: Edit Ticket]: Create Member Ticket Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const UpdateMemberTicket = createAction(
  '[Customer data: Edit Ticket]: Update Member Ticket',
);

export const UpdateMemberTicketSuccess = createAction(
  '[Customer data: Edit Ticket]: Update Member Ticket Success',
  props<{ res: any }>(),
);

export const UpdateMemberTicketFailed = createAction(
  '[Customer data: Edit Ticket]: Update Member Ticket Failed',
  props<{ error: HttpErrorResponse }>(),
);

// Coupons Panel
export const OpenCouponsPanel = createAction(
  '[Loyalty Members: Summary]: Open Coupons Panel',
  props<{ displayedColumns: { [column: string]: string } }>(),
);

export const GetCouponsTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Coupons Table Success',
  props<{ res: Coupon[] }>(),
);

export const GetCouponsTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Coupons Table Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCouponsCountSuccess = createAction(
  '[Loyalty Members: Summary]: Get Coupons Count Success',
  props<{ res: number }>(),
);

export const GetCouponsCountFailed = createAction(
  '[Loyalty Members: Summary]: Get Coupons Count Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CouponsFilterChanged = createAction(
  '[Loyalty Members: Summary]: Coupons Filter Changed',
  props<{ filter: CouponsFilter }>(),
);

export const OpenCouponReservationModal = createAction(
  '[Loyalty Members: Summary]: Open Coupon Reservation Modal',
  props<{ coupon: Coupon }>(),
);

export const OpenRemindCouponCodeModal = createAction(
  '[Loyalty Members: Summary]: Open Remind Coupon Code Modal',
  props<{ coupon: Coupon }>(),
);

export const OpenViewCouponModal = createAction(
  '[Loyalty Members: Summary]: Open View Coupon Modal',
  props<{ coupon: Coupon }>(),
);

export const OpenCouponChangeHistoryModal = createAction(
  '[Loyalty Members: Summary]: Open Coupon Change History Modal',
  props<{ coupon: Coupon }>(),
);

// Transactions (Invoices) Panel Actions
export const OpenTransactionsPanel = createAction(
  '[Loyalty Members: Summary]: Open Transactions Panel',
  props<{ displayedColumns: { [column: string]: string } }>(),
);

export const TransactionsDisplayedColumnsInit = createAction(
  '[Loyalty Members: Summary]: Transactions Displayed Columns Init',
  props<{ transactionsDisplayedColumns: { [key: string]: string } }>(),
);

export const GetTransactionsTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Transactions Table Success',
  props<{ res: any[] }>(),
);

export const GetTransactionsTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Transactions Table Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const GetTransactionsCountTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Transactions Count Table Success',
  props<{ res: number }>(),
);

export const GetTransactionsCountTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Transactions Count Table Failed',
  props<{ res: HttpErrorResponse }>(),
);

export const OpenInvoiceDetailsModal = createAction(
  '[Loyalty Members: Summary]: Open Invoice Details Modal',
  props<{ invoice: any }>(),
);

export const CloseInvoiceDetailsModal = createAction(
  '[Loyalty Members: Summary]: Close Invoice Details Modal',
);

export const OpenInvoiceAttributesModal = createAction(
  '[Loyalty Members: Summary]: Open Invoice Attributes Modal',
  props<{ invoice: any }>(),
);

export const OpenInvoiceCouponsModal = createAction(
  '[Loyalty Members: Summary]: Open Invoice Coupons Modal',
  props<{ invoice: any }>(),
);

export const OpenDeleteInvoiceModal = createAction(
  '[Loyalty Members: Summary]: Open Delete Invoice Modal',
  props<{ invoice: any }>(),
);

export const DeleteInvoice = createAction(
  '[Loyalty Members: Summary]: Delete Invoice',
  props<{ invoiceId: number }>(),
);

export const DeleteInvoiceSuccess = createAction(
  '[Loyalty Members: Summary]: Delete Invoice Success',
  props<{ res: any }>(),
);

export const DeleteInvoiceFailed = createAction(
  '[Loyalty Members: Summary]: Delete Invoice Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CloseDeleteInvoiceModal = createAction(
  '[Loyalty Members: Summary]: Close Delete Invoice Modal',
);

// Member Tags Panel
export const OpenMemberTagsPanel = createAction(
  '[Loyalty Members: Summary]: Open Member Tags Panel',
);

export const GetMemberTagsTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Member Tags Table Success',
  props<{ res: any[] }>(),
);

export const GetMemberTagsTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Member Tags Table Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetMemberTagsCountSuccess = createAction(
  '[Loyalty Members: Summary]: Get Member Tags Count Success',
  props<{ res: number }>(),
);

export const GetMemberTagsCountFailed = createAction(
  '[Loyalty Members: Summary]: Get Member Tags Count Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const MemberTagsStatusChanged = createAction(
  '[Loyalty Members: Summary]: Member Tags Status Changed',
  props<{ active: boolean }>(),
);

export const CloseMemberTag = createAction(
  '[Loyalty Members: Summary]: Close Member Tag',
  props<{ loyaltyMemberTagId: number }>(),
);

export const CloseMemberTagSuccess = createAction(
  '[Loyalty Members: Summary]: Close Member Tag Success',
);

export const CloseMemberTagFailed = createAction(
  '[Loyalty Members: Summary]: Close Member Tag Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenAssignMemberTagModal = createAction(
  '[Loyalty Members: Summary]: Open Assign Member Tag Modal',
);

export const AssignMemberTag = createAction(
  '[Loyalty Members: Summary]: Assign Member Tag',
  props<{ tagId: number; startDate: string; endDate: string | null }>(),
);

export const AssignMemberTagSuccess = createAction(
  '[Loyalty Members: Summary]: Assign Member Tag Success',
);

export const AssignMemberTagFailed = createAction(
  '[Loyalty Members: Summary]: Assign Member Tag Failed',
  props<{ error: HttpErrorResponse }>(),
);

// Member Tags pagination actions
export const MemberTagsItemsPerPageChanged = createAction(
  '[Loyalty Members: MemberTags]: Items Per Page Changed',
  props<{ itemsNumber: number }>(),
);
export const MemberTagsOrderingChanged = createAction(
  '[Loyalty Members: MemberTags]: Order Changed',
  props<{ selectedOrder: string }>(),
);
export const MemberTagsSortingChanged = createAction(
  '[Loyalty Members: MemberTags]: Sorting Changed',
  props<{ selectedSortField: string }>(),
);
export const MemberTagsPagingChanged = createAction(
  '[Loyalty Members: MemberTags]: Paging Changed',
  props<{ paginator: Paginator }>(),
);

// Customer Tags Panel
export const OpenCustomerTagsPanel = createAction(
  '[Loyalty Members: Summary]: Open Customer Tags Panel',
);

export const GetCustomerTagsTableSuccess = createAction(
  '[Loyalty Members: Summary]: Get Customer Tags Table Success',
  props<{ res: any[] }>(),
);

export const GetCustomerTagsTableFailed = createAction(
  '[Loyalty Members: Summary]: Get Customer Tags Table Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCustomerTagsCountSuccess = createAction(
  '[Loyalty Members: Summary]: Get Customer Tags Count Success',
  props<{ res: number }>(),
);

export const GetCustomerTagsCountFailed = createAction(
  '[Loyalty Members: Summary]: Get Customer Tags Count Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CustomerTagsStatusChanged = createAction(
  '[Loyalty Members: Summary]: Customer Tags Status Changed',
  props<{ active: boolean }>(),
);

export const CloseCustomerTag = createAction(
  '[Loyalty Members: Summary]: Close Customer Tag',
  props<{ customerTagId: number }>(),
);

export const CloseCustomerTagSuccess = createAction(
  '[Loyalty Members: Summary]: Close Customer Tag Success',
);

export const CloseCustomerTagFailed = createAction(
  '[Loyalty Members: Summary]: Close Customer Tag Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenAssignCustomerTagModal = createAction(
  '[Loyalty Members: Summary]: Open Assign Customer Tag Modal',
);

export const AssignCustomerTag = createAction(
  '[Loyalty Members: Summary]: Assign Customer Tag',
  props<{ tagId: number; startDate: string; endDate: string | null }>(),
);

export const AssignCustomerTagSuccess = createAction(
  '[Loyalty Members: Summary]: Assign Customer Tag Success',
);

export const AssignCustomerTagFailed = createAction(
  '[Loyalty Members: Summary]: Assign Customer Tag Failed',
  props<{ error: HttpErrorResponse }>(),
);

// Customer Tags pagination actions
export const CustomerTagsItemsPerPageChanged = createAction(
  '[Loyalty Members: CustomerTags]: Items Per Page Changed',
  props<{ itemsNumber: number }>(),
);
export const CustomerTagsOrderingChanged = createAction(
  '[Loyalty Members: CustomerTags]: Order Changed',
  props<{ selectedOrder: string }>(),
);
export const CustomerTagsSortingChanged = createAction(
  '[Loyalty Members: CustomerTags]: Sorting Changed',
  props<{ selectedSortField: string }>(),
);
export const CustomerTagsPagingChanged = createAction(
  '[Loyalty Members: CustomerTags]: Paging Changed',
  props<{ paginator: Paginator }>(),
);

// Remind MS Password
export const RemindMSPassword = createAction('[Loyalty Members: Summary]: Remind MS Password');

// Campaign Activity Timeline
export const OpenCampaignActivityTimeline = createAction(
  '[Loyalty Members: Summary]: Open Campaign Activity Timeline',
  props<{ campaignExecutionId: number }>(),
);

export const GetCampaignActionsSuccess = createAction(
  '[Loyalty Members: Summary]: Get Campaign Actions Success',
  props<{ res: any }>(),
);

export const GetCampaignActionsFailed = createAction(
  '[Loyalty Members: Summary]: Get Campaign Actions Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const PrefetchCampaignActions = createAction(
  '[Loyalty Members: Summary]: Prefetch Campaign Actions',
);

export const RemindMSPasswordSuccess = createAction(
  '[Loyalty Members: Summary]: Remind MS Password Success',
  props<{ res: any }>(),
);

export const RemindMSPasswordFailed = createAction(
  '[Loyalty Members: Summary]: Remind MS Password Failed',
  props<{ error: HttpErrorResponse }>(),
);

// Mark for Data Validation
export const MarkForDataValidation = createAction(
  '[Loyalty Members: Summary]: Mark For Data Validation',
);

export const MarkForDataValidationSuccess = createAction(
  '[Loyalty Members: Summary]: Mark For Data Validation Success',
  props<{ res: any }>(),
);

export const MarkForDataValidationFailed = createAction(
  '[Loyalty Members: Summary]: Mark For Data Validation Failed',
  props<{ error: HttpErrorResponse }>(),
);

// === Panel loading flags ===
// Dispatched (via startWith) when a panel's table request begins, so the panel can show
// its skeleton loader. The matching Get<Panel>TableSuccess/Failed clears the flag.
export const CardsPanelLoading = createAction('[Loyalty Members: Summary]: Cards Panel Loading');

export const CampaignsPanelLoading = createAction(
  '[Loyalty Members: Summary]: Campaigns Panel Loading',
);

export const CheckbooksPanelLoading = createAction(
  '[Loyalty Members: Summary]: Checkbooks Panel Loading',
);

export const PointLogPanelLoading = createAction(
  '[Loyalty Members: Summary]: Point Log Panel Loading',
);

export const TransactionsPanelLoading = createAction(
  '[Loyalty Members: Summary]: Transactions Panel Loading',
);

export const TicketsPanelLoading = createAction(
  '[Loyalty Members: Summary]: Tickets Panel Loading',
);

export const ClubsPanelLoading = createAction('[Loyalty Members: Summary]: Clubs Panel Loading');

export const CouponsPanelLoading = createAction(
  '[Loyalty Members: Summary]: Coupons Panel Loading',
);

export const MemberTagsPanelLoading = createAction(
  '[Loyalty Members: Summary]: Member Tags Panel Loading',
);

export const CustomerTagsPanelLoading = createAction(
  '[Loyalty Members: Summary]: Customer Tags Panel Loading',
);

export const ReloadLMSummaryData = createAction(
  '[Loyalty Members: Summary] Reload LM Summary Data',
);

export const ReloadLMDetailsData = createAction(
  '[Loyalty Members: Details]: Reload LM Details Data',
);

export const ReloadLMDetailsDataSuccess = createAction(
  '[Loyalty Members: Details]: Reload LM Details Data Success',
  props<{ res: any }>(),
);
